<template>
  <v-expansion-panels v-model="recommendedExpansionPanel">
    <v-expansion-panel v-for="(item, index) in recommendedCourses" :key="'rec-'+index" :disabled="hasCourse(item.course)">
      <v-expansion-panel-header>{{ item.course === 'zCore' ? item.notes : item.course + (item.notes ? ' (' + item.notes + ')' : '') }}</v-expansion-panel-header>
      <v-expansion-panel-content class="no-padding">
        <v-list>
          <course-entry
            v-for="(course, i) in item.courseOptions"
            :key="'opt-' + i"
            :course="course"
            :schedule="schedule"
            @add="addCourse(course, index)"></course-entry>
        </v-list>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<style>
div.v-expansion-panel-content.no-padding > div.v-expansion-panel-content__wrap {
  padding: 0
}
</style>
<script>
import { ref, watch } from '@vue/composition-api'
export default {
  components: {
    CourseEntry: () => import('./searchEntry')
  },
  props: {
    major: {
      type: String,
      required: true
    },
    schedule: {
      type: Array,
      default: () => { return [] }
    },
    courseSearchFilter: {
      type: Array,
      required: true
    }
  },
  setup (props, { root, emit }) {
    const recommendedExpansionPanel = ref(null)
    const recommendedCourses = ref([])

    watch(() => props.major, (major) => {
      if (root.$store.state.term !== '' && major != null && major !== '') {
        // Load the recommended courses for the selected major
        root.$feathers.service('warehouse/recommended-courses').find({ query: { major } }).then(async ({ data }) => {
          recommendedCourses.value = []
          if (data.length > 0) {
            for (const { course, notes } of data) {
              let temp = { course, notes }
              if (course !== 'zCore') {
                let query = { course_num: course, term_code: root.$store.state.term, $limit: 50 }
                if (course === 'MUS10') query.course_num = { $like: 'MUS10%' }
                let { data: courses } = await root.$feathers.service('warehouse/courses').find({ query })
                temp.courseOptions = courses
              }
              recommendedCourses.value.push(temp)
            }
          }
        })
      }
    })

    function hasCourse (course) {
      if (course === 'zCore') return true
      for (let i = 0; i < props.courseSearchFilter.length; i++) {
        if (props.courseSearchFilter[i] === course || (course === 'BIB111' && props.courseSearchFilter[i] === 'BIB142') || (course === 'BIB142' && props.courseSearchFilter[i] === 'BIB111')) return true
      }
      return false
    }

    function addCourse (course) {
      recommendedExpansionPanel.value = null
      emit('addCourse', course)
    }

    return {
      recommendedExpansionPanel,
      recommendedCourses,
      hasCourse,
      addCourse
    }
  }
}
</script>
